import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Context } from '../../context/Context';
import { StyledSubPageNavigation } from './SubPageNavigationStyles';
// import { getViewportSize, setHeight, throttle } from '../../utils/utils';
import { SUBMENUID, TRIGGERID } from '../../ContentType';
import { getViewportSize, setHeight } from '../../utils/utils';
import MainMenu from './mainmenu/MainMenu';
import Submenu from './submenu/Submenu';
import StickyButton from './ui/StickyButtons';

const SubPageNavigation: React.FC = () => {
  const {
    isPopOverOpen,
    setPopOverState,
    submenuDesktopRef,
    submenuMobileRef,
    showSubmenu,
    toggleShowSubmenu,
    setTriggerId,
    setSubmenuId,
    stickymode,
    content: { fascinationMode },
  } = useContext(Context);
  const scrollCheckRef = useRef<HTMLDivElement>(null);
  const animationRef = useRef<HTMLDivElement>(null);
  const [fascinationClass, setFascinationClass] = useState<undefined | 'show' | 'hide'>();

  const renderMobileMenu = () => {
    if (submenuMobileRef.current) {
      setHeight(submenuMobileRef.current, showSubmenu);
    }
  };

  const renderDesktopMenu = () => {
    if (submenuDesktopRef.current) {
      setHeight(submenuDesktopRef.current, showSubmenu);
    }
  };

  const setDesktopEventIds = () => {
    setTriggerId(TRIGGERID.DESKTOP);
    setSubmenuId(SUBMENUID.DESKTOP);
  };

  const setMobileEventIds = () => {
    setTriggerId(TRIGGERID.MOBILE);
    setSubmenuId(SUBMENUID.MOBILE);
  };

  useEffect(() => {
    renderMobileMenu();
    renderDesktopMenu();
  }, [showSubmenu]);

  const handleResize = useCallback(() => {
    const viewportSize = getViewportSize();

    if (viewportSize === 'tablet' && showSubmenu) {
      toggleShowSubmenu();
    }

    if (viewportSize === 'mobile' || viewportSize === 'tablet') {
      setMobileEventIds();
    } else {
      setDesktopEventIds();
    }

    setPopOverState(false);
  }, [showSubmenu, setPopOverState]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  useEffect(() => {
    if (isPopOverOpen && showSubmenu) {
      toggleShowSubmenu();
    }
  }, [isPopOverOpen]);

  useEffect(() => {
    const handleScroll = () => {
      if (!scrollCheckRef.current) return;

      const rect = scrollCheckRef.current.getBoundingClientRect();
      const { scrollY } = window;
      const elementTop = scrollY + rect.top;

      /*
       * Scroll thresholds by viewport width:
       * - < 768px  -> 800px
       * - ≥ 768px  -> 900px
       * - ≥ 1024px -> 600px
       */

      const viewportWidth = window.innerWidth;
      let scrollThreshold = 800;

      if (viewportWidth >= 1024) {
        scrollThreshold = 600;
      } else if (viewportWidth >= 768) {
        scrollThreshold = 900;
      }
      const scrolledPast = scrollY >= elementTop + scrollThreshold;

      setFascinationClass((old) => {
        if (old !== 'show' && scrolledPast) {
          return 'show';
        }
        if (old === 'show' && !scrolledPast) {
          return 'hide';
        }
        return old;
      });
    };

    const target = animationRef.current;
    if (target) {
      target.addEventListener('animationend', () => {
        if (target.classList.contains('hide')) {
          setFascinationClass(undefined);
        }
      });
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // close submenu if opened when subpage navi disapears whith fascination mode
  useEffect(() => {
    if (!fascinationMode || process.env.IS_LEGACY) return;
    if (fascinationClass !== 'show' && showSubmenu) {
      toggleShowSubmenu();
    }
  }, [fascinationMode, fascinationClass, showSubmenu]);

  return (
    <>
      <div ref={scrollCheckRef} />
      <StyledSubPageNavigation
        data-testid="subpage-navigation-container"
        isSticky={stickymode}
        fascinationMode={fascinationMode}
        className={fascinationClass}
        ref={animationRef}
      >
        <MainMenu />
        <StickyButton />
        <Submenu />
      </StyledSubPageNavigation>
    </>
  );
};
export default SubPageNavigation;
